import { takeEvery, put, call, select, all } from "redux-saga/effects"

import {
  DOWNLOAD_FILE_S3_WRAP,
  // Multiples
  POST_MULTIPLES_FILES,
  DELETE_MULTIPLES_FILES,
} from "./constants"

import {
  responseTypeIsError,
  responseTypeIsSuccess,
  manageErrorGenerator,
} from "Containers/App/saga"

// Utils
import request from "Utils/request"
import { config } from "Utils/config"
import { deleteCors } from "Utils/rulesCors"

// Actions
import { setErrorMessage } from "Containers/Messages/actions"

// Selectors
import { selectCurrentToken } from "Containers/Login/selectors.js"
import { fetchFileFromApi, uploadFile } from "Shared/utils/file"
import { removeUuidFromFilename } from "Shared/utils/format.utils"

export const extractUUIDFromFilename = filename => {
  const regex = /^[0-9a-fA-F-]{36}/ // Regex pour capturer un UUID v4 au début du nom
  const match = filename.match(regex)
  return match ? match[0] : null
}

// ------------- SAGAS ------------------//
export function* manageFilesETLsaga(payload) {
  if (!payload) return
  const { filesToUploadETL, filesToRemoveETL } = payload
  if (!Array.isArray(filesToUploadETL) || !Array.isArray(filesToRemoveETL)) {
    return {}
  }
  const removedFiles = yield call(deleteMultiplesFiles, filesToRemoveETL)
  const uploadedFiles = yield call(postMultiplesFiles, filesToUploadETL)
  return { uploadedFiles, removedFiles }
}

export function* postFileToS3(payload) {
  const file = payload
  const token = yield select(selectCurrentToken)

  try {
    // Appel de la fonction uploadFile
    const { filename, UploadId, fileId, status } = yield call(uploadFile, file, token)

    if (!filename) {
      throw new Error("L'upload du fichier a échoué")
    }

    if (status == "201" || status == "200") {
      return {
        body: {
          name: filename,
          uuid: extractUUIDFromFilename(filename),
          nanoid: extractUUIDFromFilename(filename),
        },
        type: "success",
      }
    } else {
      yield call(manageErrorGenerator, { respons: { code: "500" }, showMessageToUser: false })
    }
  } catch (err) {
    console.error(`[route] => v1/files => ERROR POST FILE ETL=> `, err)
    yield put(setErrorMessage(err))
  }
}

export function* downloadFileS3(fileName) {
  try {
    const token = yield select(selectCurrentToken)
    const { data, contentType } = yield call(fetchFileFromApi, fileName, token)
    const blob = new Blob([data], { type: contentType })
    const fileNameWithoutUuid = removeUuidFromFilename(fileName)
    const fileURL = URL.createObjectURL(blob)

    const link = document.createElement("a")
    link.href = fileURL
    link.setAttribute("download", fileNameWithoutUuid)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    return { status: 200 }
  } catch (error) {
    return { status: 500, message: error.message }
  }
}

export function* postMultiplesFiles(payload) {
  const filesToPost = payload
  if (!Array.isArray(filesToPost)) return console.log("Files to post need to be an array")
  const uploadedFiles = []
  for (let file of filesToPost) {
    const { originalName, fileData, s3 } = file

    let responsePostFile = null

    responsePostFile = yield call(postFileToS3, fileData)

    let newUploadedFile = {
      originalName: originalName,
      uploadedDate: new Date().toISOString(),
      uploadStatus: "failed",
    }

    if (responseTypeIsSuccess(responsePostFile)) {
      newUploadedFile["uploadStatus"] = "success"
      newUploadedFile["fileName"] = responsePostFile?.body?.name
      newUploadedFile["uuid"] = responsePostFile?.body?.uuid
      newUploadedFile["nanoid"] = responsePostFile?.body?.nanoid
      if (s3) {
        newUploadedFile["s3"] = true
      }
    }

    uploadedFiles.push(newUploadedFile)
  }
  return uploadedFiles
}

export function deleteFileToS3(payload) {
  // Il n'existe pas encore de route back, a faire
  // on va simuler la suppression
  return { body: {}, type: "success" }
}

export function* deleteFileETL(payload) {
  const fileName = payload
  
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { API_URL } = config
  const endPath = `/v1/files/${fileName}`
  const requestURL = `${API_URL}${endPath}`

  try {
    const response_deleteFile = yield call(request, requestURL, deleteCors(specificHeaders))
    if (responseTypeIsError(response_deleteFile))
      yield call(manageErrorGenerator, { response_deleteFile, showMessageToUser: false })
    else return response_deleteFile
  } catch (err) {
    console.error(`[route] => ${endPath} => ERROR DELETE FILE ETL=> `, err)
    yield put(setErrorMessage(err))
  }
}

export function* deleteMultiplesFiles(payload) {
  const filesToDelete = payload
  if (!Array.isArray(filesToDelete)) return console.log("Files to delete need to be an array")
  const deletedFiles = []
  for (let file of filesToDelete) {
    const { fileName, s3 } = file
    let responseDeleteFile = null
    if (s3) {
      responseDeleteFile = yield call(deleteFileToS3, fileName)
    } else {
      responseDeleteFile = yield call(deleteFileETL, fileName)
    }

    let newDeletedFile = { ...file, deletedStatus: "failed" }
    if (responseTypeIsSuccess(responseDeleteFile)) {
      newDeletedFile["deletedStatus"] = "success"
    }
    deletedFiles.push(newDeletedFile)
  }
  return deletedFiles
}

export function* downloadFileS3Wrap({ payload }) {
  try {
    const { fileName } = payload
    const response = yield call(downloadFileS3, fileName)
    if (response.status !== 200) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    }
  } catch (err) {
    console.error(`[route] => downloadFileETL => ERROR => `, err)
    yield put(setErrorMessage(err))
  }
}

function* ETLSaga() {
  yield takeEvery(DOWNLOAD_FILE_S3_WRAP, downloadFileS3Wrap)
  // Multiples
  yield takeEvery(POST_MULTIPLES_FILES, postMultiplesFiles)
  yield takeEvery(DELETE_MULTIPLES_FILES, deleteMultiplesFiles)
}

export default ETLSaga
